"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var FinanceRevshareEditor = /** @class */ (function (_super) {
    __extends(FinanceRevshareEditor, _super);
    function FinanceRevshareEditor(props) {
        return _super.call(this, props) || this;
    }
    FinanceRevshareEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_APP = this.props.pprogramsList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_pprograms: data.data,
                avail_partners: [],
                partner_id: 0,
                partner_title: "",
                avail_offers: [],
                offer_id: 0,
                offer_title: "",
            });
        });
        this.SID_APT = this.props.pprogramPartnersList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_partners: data.data,
                avail_offers: [],
                offer_id: 0,
                offer_title: "",
            });
        });
        this.SID_AOF = this.props.pprogramPartnersOffersList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_offers: data.data
            });
        });
        this.setState({
            pprogram_id: 0,
            pprogram_title: "",
            avail_pprograms: [],
            partner_id: 0,
            partner_title: "",
            avail_partners: [],
            offer_id: 0,
            offer_title: "",
            avail_offers: [],
            amount: 0,
            description: "",
            revshare_type_code: 0,
            revshare_type_title: ""
        }, function () {
            _this.loadPProgramsAvail();
        });
        this.doReSetRules();
    };
    FinanceRevshareEditor.prototype.loadPProgramsAvail = function () {
        this.props.pprogramsList.LoadData();
    };
    FinanceRevshareEditor.prototype.componentWillUnmount = function () {
        this.props.pprogramsList.UnSubscribe(this.SID_APP);
        this.props.pprogramPartnersList.UnSubscribe(this.SID_APT);
        this.props.pprogramPartnersOffersList.UnSubscribe(this.SID_AOF);
    };
    FinanceRevshareEditor.prototype.doReSetRules = function () {
        this.setState({
            pprogram_rules: { isError: false },
            partner_rules: { isError: false },
            offer_rules: { isError: false },
            amount_rules: { isError: false },
            revshare_type_rules: { isError: false }
        });
    };
    FinanceRevshareEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.pprogram_id <= 0) || (this.state.pprogram_title.length === 0)) {
            this.setState({ pprogram_rules: { isError: true, errorMessage: "Партнерская программа не выбрана!" } });
            return false;
        }
        if ((this.state.partner_id <= 0) || (this.state.partner_title.length === 0)) {
            this.setState({ partner_rules: { isError: true, errorMessage: "Партнер не выбран!" } });
            return false;
        }
        if ((!this.state.offer_id) || (this.state.offer_title.length === 0)) {
            this.setState({ offer_rules: { isError: true, errorMessage: "Оффер партнера не выбран!" } });
            return false;
        }
        if (this.state.revshare_type_code != 3) { //reset zero balance
            if ((!this.state.amount) || (this.state.amount <= 0)) {
                this.setState({ amount_rules: { isError: true, errorMessage: "Сумма перевода заполнена некорректно!" } });
                return false;
            }
        }
        if ((!this.state.revshare_type_code) || (this.state.revshare_type_title.length === 0)) {
            this.setState({ revshare_type_rules: { isError: true, errorMessage: "Тип выплаты не выбран!" } });
            return false;
        }
        return true;
    };
    FinanceRevshareEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_partner_id: this.state.partner_id,
                brand_offer_id: this.state.offer_id,
                amount: this.state.amount,
                description: this.state.description,
                revshare_type_code: this.state.revshare_type_code
                //  total_bet_amount: this.state.total_bet_amount,
                //   is_not_withdraw_amount_from_next_balance: this.state.is_not_withdraw_amount_from_next_balance
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Выплата по ревшаре П.Программы добавлена!");
            });
        }
    };
    FinanceRevshareEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    FinanceRevshareEditor.prototype.getFormTitle = function () {
        return "Новая выплата по ревшаре П.Программы";
    };
    FinanceRevshareEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 540 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип выплаты:", placeholder: "Выберите тип выплаты" }, value: { key: this.state.revshare_type_code, value: this.state.revshare_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        revshare_type_code: newVal.key,
                        revshare_type_title: newVal.value,
                        revshare_type_rules: { isError: false }
                    });
                }, items: this.props.availRevshareFlowTypes, required: true, rules: this.state.revshare_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "П.Программа:", placeholder: "Выберите партнерскую программу" }, value: { key: this.state.pprogram_id, value: this.state.pprogram_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        pprogram_id: newVal.key,
                        pprogram_title: newVal.value,
                        pprogram_rules: { isError: false }
                    }, function () {
                        _this.props.pprogramPartnersList.LoadData(_this.state.pprogram_id);
                    });
                }, items: this.state.avail_pprograms, required: true, rules: this.state.pprogram_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Партнер:", placeholder: "Выберите партнера" }, value: { key: this.state.partner_id, value: this.state.partner_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        partner_id: newVal.key,
                        partner_title: newVal.value,
                        partner_rules: { isError: false }
                    }, function () {
                        _this.props.pprogramPartnersOffersList.LoadData(_this.state.partner_id);
                    });
                }, items: this.state.avail_partners, required: true, rules: this.state.partner_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Оффер:", placeholder: "Выберите оффер" }, value: { key: this.state.offer_id, value: this.state.offer_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        offer_id: newVal.key,
                        offer_title: newVal.value,
                        offer_rules: { isError: false }
                    });
                }, items: this.state.avail_offers, required: true, rules: this.state.offer_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма:", placeholder: "Введите сумму выплаты" }, values: { max: 9999999, min: 0.01, value: this.state.amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        amount: newVal,
                        amount_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.amount_rules, disabled: this.state.revshare_type_code == 3 }),
            React.createElement(CardRowButtonSet_1.default, { editMode: false, title: { btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return FinanceRevshareEditor;
}(React.Component));
exports.default = FinanceRevshareEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_revshares_list/ui/component/FinanceRevshareEditor.tsx
// module id = 2455
// module chunks = 0